import React from "react";
import ProtectedRoute from "./permitRoutes";
import NotAuthorized from "../pages/NotAuth";
import StockReportWithProducts from "../pages/StockReportWithProducts";
import HourlyProductSummary from "../pages/restaurant/HourlyProductWiseSummary";
import ProductsList from "../pages/ProductsList";
import ReOrder from "../pages/ReOrder";
import DayCloseCash from "../pages/DayCloseCash";

const Login = React.lazy(() => import("../pages/Login"));
const Dashboard = React.lazy(() => import("../pages/Dashboard"));

const RestaurantDashboard = React.lazy(
  () => import("../pages/restaurant/RestaurantDashboard"),
);
const TimeWiseDailySummary = React.lazy(
  () => import("../pages/restaurant/TimeWiseDailySummary"),
);
const MonthWiseSummary = React.lazy(
  () => import("../pages/restaurant/MonthWiseSummary"),
);
const DayWiseSummary = React.lazy(
  () => import("../pages/restaurant/DayWiseSummary"),
);
const WaiterWiseSummary = React.lazy(
  () => import("../pages/restaurant/WaiterWiseSummary"),
);
const InvoiceWiseDailySummary = React.lazy(
  () => import("../pages/restaurant/InvoiceWiseSummary"),
);
const PaymentSummary = React.lazy(
  () => import("../pages/restaurant/PaymentSummary"),
);
const SalesSummary = React.lazy(
  () => import("../pages/restaurant/SalesSummary"),
);
const LiveOrderSummary = React.lazy(
  () => import("../pages/restaurant/LiveOrderSummary"),
);

const DepartmentWiseSales = React.lazy(() => import("../pages/DeptWiseSales"));
const HourlySales = React.lazy(() => import("../pages/HourlySales"));
const StockReport = React.lazy(() => import("../pages/StockReport"));
const TopSellingProducts = React.lazy(
  () => import("../pages/TopSellingProducts"),
);
const InvoiceSales = React.lazy(() => import("../pages/InvoiceSales"));
const Saleswise = React.lazy(() => import("../pages/Saleswise"));
const UsersList = React.lazy(() => import("../pages/UsersList"));
const UsersPermission = React.lazy(() => import("../pages/UsersPermission"));
const Chat = React.lazy(() => import("../pages/Chat"));

const userType = parseInt(sessionStorage.getItem("userType"));

let defaultDashboard = <Login />;
if ([3, 4, 5].includes(userType)) {
  defaultDashboard = <Dashboard />;
}

const authProtectedRoutes = [
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/restaurantdashboard", element: <RestaurantDashboard /> },
  { path: "/time-wise-daily-summary", element: <TimeWiseDailySummary /> },
  { path: "/month-wise-summary", element: <MonthWiseSummary /> },
  { path: "/day-wise-summary", element: <DayWiseSummary /> },
  { path: "/waiter-wise-summary", element: <WaiterWiseSummary /> },
  { path: "/invoice-wise-summary", element: <InvoiceWiseDailySummary /> },
  { path: "/payment-wise-summary", element: <PaymentSummary /> },
  { path: "/hourly-product-wise-summary", element: <HourlyProductSummary /> },
  { path: "/sales-wise-summary", element: <SalesSummary /> },
  { path: "/live-order-wise-summary", element: <LiveOrderSummary /> },
  { path: "/dept-sales", element: <DepartmentWiseSales /> },
  { path: "/products-list", element: <ProductsList /> },
  { path: "/hourly-sales", element: <HourlySales /> },
  { path: "/top-products", element: <TopSellingProducts /> },
  { path: "/stock-report", element: <StockReport /> },
  { path: "/stock-report-with-products", element: <StockReportWithProducts /> },
  { path: "/invoice-sales", element: <InvoiceSales /> },
  { path: "/salesman-sales", element: <Saleswise /> },
  {
    path: "/users-list",
    element: (
      <ProtectedRoute submenuPageId={"1"}>
        <UsersList />
      </ProtectedRoute>
    ),
  },
  {
    path: "/users-permission",
    element: (
      <ProtectedRoute submenuPageId={"2"}>
        <UsersPermission />
      </ProtectedRoute>
    ),
  },
  { path: "/", element: defaultDashboard },
  { path: "/not-authorized", element: <NotAuthorized /> },
  { pagename: "insight", path: "/dashboard", element: <Dashboard /> },

  {
    pagename: "restaurantinsight",
    path: "/restaurantdashboard",
    element: <RestaurantDashboard />,
  },
  {
    pagename: "dailytimewisesalessummary",
    path: "/time-wise-daily-summary",
    element: <TimeWiseDailySummary />,
  },
  {
    pagename: "monthwisesalessummary",
    path: "/month-wise-summary",
    element: <MonthWiseSummary />,
  },
  {
    pagename: "daywisesalessummary",
    path: "/day-wise-summary",
    element: <DayWiseSummary />,
  },
  {
    pagename: "dailywaiterwisesummary",
    path: "/waiter-wise-summary",
    element: <WaiterWiseSummary />,
  },
  {
    pagename: "dailyinvoicecountsummary",
    path: "/invoice-wise-summary",
    element: <InvoiceWiseDailySummary />,
  },
  {
    pagename: "dailypaymentsummary",
    path: "/payment-wise-summary",
    element: <PaymentSummary />,
  },
  {
    pagename: "hourlyproductsummary",
    path: "/hourly-product-wise-summary",
    element: <HourlyProductSummary />,
  },
  {
    pagename: "dailysalessummary",
    path: "/sales-wise-summary",
    element: <SalesSummary />,
  },
  {
    pagename: "dailyliveorderssummary",
    path: "/live-order-wise-summary",
    element: <LiveOrderSummary />,
  },

  {
    pagename: "departmentwisesales",
    path: "/dept-sales",
    element: <DepartmentWiseSales />,
  },
  {
    pagename: "productslist",
    path: "/products-list",
    element: <ProductsList />,
  },
  {
    pagename: "dayclosecash",
    path: "/day-close-cash",
    element: <DayCloseCash />,
  },
  {
    pagename: "reorder",
    path: "/reorder",
    element: <ReOrder />,
  },
  { pagename: "hourlysales", path: "/hourly-sales", element: <HourlySales /> },
  {
    pagename: "topsellingproducts",
    path: "/top-products",
    element: <TopSellingProducts />,
  },
  { pagename: "stockreport", path: "/stock-report", element: <StockReport /> },
  {
    pagename: "stockreport",
    path: "/stock-report-with-products",
    element: <StockReportWithProducts />,
  },
  {
    pagename: "invoicewisesales",
    path: "/invoice-sales",
    element: <InvoiceSales />,
  },
  {
    pagename: "salesmanwisesales",
    path: "/salesman-sales",
    element: <Saleswise />,
  },
  {
    pagename: "",
    path: "/users-list",
    element: (
      <ProtectedRoute submenuPageId={"1"}>
        <UsersList />
      </ProtectedRoute>
    ),
  },
  {
    pagename: "",
    path: "/users-permission",
    element: (
      <ProtectedRoute submenuPageId={"2"}>
        <UsersPermission />
      </ProtectedRoute>
    ),
  },
  { pagename: "insight", path: "/", element: defaultDashboard },
  { pagename: "", path: "/not-authorized", element: <NotAuthorized /> },
];

const publicRoutes = [{ path: "/login", element: <Login /> }];

export { authProtectedRoutes, publicRoutes };
